import {
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query";
import { KeyboardNavigationProvider } from "keyboardNavigation/KeyboardNavigationSystem";
import { ModalsProvider } from "Modals/ModalsProvider";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { SessionProvider } from "./SessionContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const DefaultProviders = (props: React.PropsWithChildren<unknown>) => {
  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        <ModalsProvider>
          <KeyboardNavigationProvider>
            {props.children}
            {/* <ReactQueryDevtools /> */}
          </KeyboardNavigationProvider>
        </ModalsProvider>
      </QueryClientProvider>
    </SessionProvider>
  );
};

export default DefaultProviders;